import ApiHandler from "./ApiHandler";

const FinalStepRequest = {
  getAll: async () => await ApiHandler.i.auth().get('/final-step-request'),
  getOne: async (requestId) => await ApiHandler.i.auth().get(`/final-step-request/${requestId}`),
  getRequested: async (query) => await ApiHandler.i.auth().get(`/final-step-request/requested?${query.toString()}`),
  postOne: async (data, options) => await ApiHandler.i.auth().post('/final-step-request', data, options),
  putApprove: async (requestId) => await ApiHandler.i.auth().put(`/final-step-request/${requestId}/approve`, {}),
  putDeny: async (requestId, data, options) => await ApiHandler.i.auth().put(`/final-step-request/${requestId}/deny`, data, options),
  putReopen: async (requestId, data, options) => await ApiHandler.i.auth().put(`/final-step-request/${requestId}/reopen`, data, options),
};

export default FinalStepRequest;